const zh = {
  translation: {
    selectLanguage: "选择语言",
    saveButton: "节省",
    footerText:
      "Enatega 是一个开源交付管理平台 未来。我们优先考虑创新、灵活性和可承受性，并提供可扩展、可定制的解决方案，简化您的 交付流程",
    footerLinkHome: "主页",
    footerLinkPP: "隐私政策",
    footerLinkTC: "条款和条件",
    footerEndText: "Enatega - © 2022 版权所有",
    followUs: "关注我们",
    poweredBy: "由...提供动力",
    linksTitle: "链接",
    subTotal: "小计",
    deliveryFee: "快递费",
    haveVoucher: "你有优惠券吗",
    remove: "去掉",
    change: "更改",
    taxFee: "税费",
    total: "总",
    tip: "小费",
    discount: "折扣",
    name: "名称",
    phone: "电话",
    email: "电子邮件",
    address: "地址",
    changeAddress: "更改地址",
    contactInfo: "联系信息",
    paymentMethod: "付款方法",
    orderBtn: "下订单",
    deliveryTime: "送货时间",
    delivery: "送货",
    searchRestaurantPlaceholder: "搜索餐厅和菜系",
    allRestaurant: "所有餐厅",
    pending: "待定",
    accepted: "已接受",
    assigned: "已分配",
    picked: "已接",
    delivered: "已送达",
    completed: "已完成",
    titleOrders: "我的订单",
    titleProfile: "轮廓",
    titleHelp: "救命",
    titleSettings: "设置",
    titleChat: "聊",
    titleLogout: "登出",
    passwordInfo: "密码信息",
    myAddresses: "我的地址",
    edit: "编辑",
    creditDebitCard: "信用卡 / 借记卡",
    paypal: "贝宝",
    cash: "现金",
    deliverTo: "递送至",
    ASSIGNED: "已分配",
    PENDING: "待定",
    PICKED: "已取货",
    ACCEPTED: "已接受",
    DELIVERED: "已交付",
    COMPLETED: "已完成",
    orderPlaced: "订单已下达",
    "Order ID": "订单号",
    "Order status: PENDING": "订单状态：待处理",
    "Order status: ACCEPTED": "订单状态：已接受",
    "Order status: ASSIGNED": "订单状态：已分配",
    "Order status: PICKED": "订单状态：已挑选",
    "Order status: DELIVERED": "订单状态：已交付",
    "Order status: Order Placed": "订单状态：已下订单",
    deliveryAddress: "邮寄地址",
    orderDetail: "订单详情",
    orderFrom: "您的订单来自",
    orderNo: "您的订单号",
    findRestaurants: "寻找餐厅",
    putUsInYourPocket: "把我们装进你的口袋里",
    containerText:
      "一切尽在掌握之中 - 你喜爱的餐厅。找到适合你心情的美食，让第一口持续留香。来吧，下载我们",
    findingAddress: "使用GPS集成找地址",
    zonesFunctionality: "针对餐厅和骑手的区域功能",
    multipleRestaurants: "多个餐厅添加功能",
    realTimeOrder: " 实时订单接收更新",
    differentSections: "为推广餐厅设置不同板块功能",
    previousOrder: "查看以往订单历史和添加喜爱餐厅",
    ourDelivery: "我们的送货管理系统是为未来设计的",
    builtOnCommunity: "基于社区驱动的原则构建",
    yourCart: "您的购物车",
    startAdding: "开始将商品加入购物车",
    goToCheckout: "去结账",
    activeOrders: "活跃订单",
    pastOrders: "历史订单",
    deliveringTo: "送货至",
    restaurantDeliver: "我们正在询问餐厅送餐需要多长时间",
    riderDeliver: "我们正在询问骑手送餐需要多长时间",
    orderPending: "您的订单仍在等待中",
    areYouSure: "你确定吗？",
    clearCartText: "更改餐厅将清除您添加到购物车的物品",
    ok: "好的",
    cancel: "取消",
    submit: "提交",
    titleFavourite: "喜爱",
    titleEmptyFav: "没有收藏夹",
    emptyFavDesc: "您会在这里看到所有收藏夹，以加快订购速度。",
    emptyFavBtn: "让我们找到一些最爱",
    exactLocation: "这是您的确切位置吗？",
    yourArea: "输入您的地区",
    currentLocation: "使用当前位置",
    deliveryDetails: "必填详细信息-例如 楼层/建筑物",
    deliveryDetailError: "需要送货详情",
    currentPassword: "当前密码",
    newPassword: "新密码",
    deliver: "送货",
    time: "时间",
    pickup: "取货",
    selectTime: "选择时间",
    am: "上午",
    pm: "下午",
    set: "设置",
    apply: "申请",
    applyAVoucher: "使用优惠券",
    readAll: "阅读全部",
    readMore: "阅读更多",
    demo: "演示",
    getQuote: "获取报价",
    restaurantCloseText:
      "该餐厅目前已关闭。查看其他开放的餐厅或浏览菜单，计划下一餐。",
    seeOtherRestaurants: "查看其他餐厅",
    goToMenu: "进入菜单",
    deliveryHours: "送货时间",
    about: "关于",
    reviews: "评价",
    closedAllDay: "全天关闭",
    minute: "分钟",
    welcome: "欢迎！",
    signUpOrLogin: "注册或登录以继续",
    signInWithGoogle: "继续使用 Google",
    or: "或者",
    continueWithEmail: "继续使用电子邮件",
    terms: "条款和条件",
    privacyPolicy: "隐私政策",
    bySigningUp: "通过注册，您同意我们的",
    and: " 和 ",
    whatsYourEmail: "你的电子邮件是什么？",
    checkAccount: "我们会检查你是否有账户",
    continue: "继续",
    invalidEmail: "无效的电子邮件",
    letsGetStarted: "让我们开始吧！",
    createAccount: "创建您的 Enatega 账户",
    firstnameErr1: "名字是必填项！",
    firstnameErr2: "无效的名字！",
    lastnameErr1: "姓氏是必填项！",
    lastnameErr2: "无效的姓氏！",
    mobileErr1: "电话号码是必填项！",
    mobileErr2: "无效的电话号码！",
    emailErr2: "无效的电子邮件",
    passwordErr1:
      "无效的密码。密码必须至少包含1个大写字母、1个小写字母和1个数字。",
    passwordErr2: "无效的密码",
    generalErr: "有东西缺失",
    verifyEmail: "验证您的电子邮件",
    enterOtp: "请输入我们发送到您更新的电子邮件的OTP",
    enterOtpPhone : "请输入我们发送到您更新的电话号码的OTP",
    invalidCode: "无效的代码，请检查并重新输入",
    resendCode: "重新发送代码",
    retryAfter: "稍后重试",
    loginBtn: "登录",
    addToCart: "添加到购物车",
    customize: "自定义",
    optional: "可选的",
    required: "必需的",
    specialInstructions: "特别说明",
    anySpecific: "有什么特别的喜好吗？告诉餐厅。",
    selectVariation: "选择变体",
    closed: "关闭",
    new: "新",
    orderCancelled: "您的订单已取消",
    orderCompleted: "订单已成功完成。感谢您的订购",
    reorder: "重新订购",
    review: "评论",
    subTitle: "选择 1",
    placeholder: "例如，不要蛋黄酱",
    phoneNumMissing: "电话号码缺失",
    updatePhone: "更新您的电话",
    number: "号码？",
    secureAcc: "我们需要这个来保护您的账户",
    verifyPhone: "验证您的电话",
    skipNow: "现在跳过",
    favouriteListUpdated: "收藏列表已更新",
    pendingText: "等待来自的回复",
    acceptedText: "预计准备时间",
    orderLateText: "抱歉！您的订单有点晚了。",
    riderPickText: "您的骑手会在准备好后取货。",
    orderIs: "您的订单是",
    orderAssigned: "分配给骑手",
    orderAssignedToRider: "您的订单已分配给我们的骑手，订单准备好后将被取货。",
    riderOnWay: "您的骑手正在路上。",
    orderHasBeen: "您的订单已",
    enjoyYourMeal: "享用您的餐点！",
    cancelled: "已取消",
    personalDetail: "个人详情",
    voucherCode: "优惠码",
    pickUp: "取件",
    warning: "警告",
    warningText: "一个或多个项目不可用",
  },
};
export default zh;
